export class ScoreAnimation {
    constructor() {
        this.animationContainer = document.createElement('div');
        this.animationContainer.style.position = 'fixed';
        this.animationContainer.style.pointerEvents = 'none';
        document.body.appendChild(this.animationContainer);
    }

    showScoreAnimation(points, x, y) {
        const scoreElement = document.createElement('div');
        scoreElement.textContent = `+${points}`;
        scoreElement.style.position = 'absolute';
        scoreElement.style.left = `${x}px`;
        scoreElement.style.top = `${y}px`;
        scoreElement.style.color = '#ffeb3b';
        scoreElement.style.fontSize = '24px';
        scoreElement.style.fontWeight = 'bold';
        scoreElement.style.textShadow = '2px 2px 4px rgba(0,0,0,0.5)';
        scoreElement.style.transition = 'all 1s ease-out';
        scoreElement.style.zIndex = '9999';
        scoreElement.style.opacity = '1';
        scoreElement.style.transform = 'translateY(0)';
        
        this.animationContainer.appendChild(scoreElement);

        // 开始动画
        requestAnimationFrame(() => {
            scoreElement.style.transform = 'translateY(-50px) scale(1.2)';
            scoreElement.style.opacity = '0';
        });

        // 动画结束后移除元素
        setTimeout(() => {
            if (scoreElement.parentNode === this.animationContainer) {
                this.animationContainer.removeChild(scoreElement);
            }
        }, 1000);
    }

    // 清理方法
    dispose() {
        if (this.animationContainer && this.animationContainer.parentNode) {
            this.animationContainer.parentNode.removeChild(this.animationContainer);
        }
    }
}